export * from './ModuleFE_FHIRResource.js';
export * from './module-pack.js';
//# sourceMappingURL=index.js.map